import { taskStatesSchema } from "@models";
import { useQuery } from "@tanstack/react-query";
import { getTaskStatesQueryKey } from "../../config";
import { getTaskStates } from "../../services";

export const getTaskStatesParams = ({
  orgId,
  deviceId,
  enabled = true,
}: {
  orgId: string;
  deviceId: string;
  enabled?: boolean;
}) => {
  return {
    queryKey: getTaskStatesQueryKey(orgId, deviceId),
    queryFn: async () => {
      const { data, status } = await getTaskStates(orgId, deviceId);
      if (status !== 200) {
        return [];
      }
      const states = await taskStatesSchema.validate(data);
      return states ?? [];
    },
    enabled,
  };
};

export const useGetTaskStates = ({
  orgId,
  deviceId,
  enabled = true,
}: {
  orgId: string;
  deviceId: string;
  enabled?: boolean;
}) => {
  return useQuery(getTaskStatesParams({ orgId, deviceId, enabled }));
};
